module.exports = function ($sce, settingsService, $stateParams, searchPhraseActionService, $state, shopperService) {
    function SearchExternalResultsController() {

        // If the search phrase isn't associated with an action
        // Or if the action was to prompt for login and user is not a guest, do normal search
        searchPhraseActionService.getSearchPhraseAction($stateParams.searchTerm).then((action) => {
            if (!action || (action.Action === searchPhraseActionService.action.login && !shopperService.IsGuest)) {
                $state.go('shop.search', { searchTerm: $stateParams.searchTerm, multisearchItems: $stateParams.multisearchItems }, { inherit: false, reload: true, location: 'replace' });
            }
        });

        settingsService.getSettingValue('Search', 'SearchResultInNewTab').then((setting) => {
            const externalResultMessageBeforeAfter = setting.split('{searchTerm}');
            this.SearchTerm = $stateParams.searchTerm;
            this.ExternalResultMessageBefore = $sce.trustAsHtml(externalResultMessageBeforeAfter[0]);
            this.ExternalResultMessageAfter = $sce.trustAsHtml(externalResultMessageBeforeAfter[1]);
        });
    }

    return {
        restrict: 'E',
        scope: {},
        bindToController: true,
        controllerAs: 'ctrl',
        controller: [SearchExternalResultsController],
        template: '<div class="search-zero-results-wrapper"><div class="search-zero-results-wrapper-blurb"><span ng-bind-html="ctrl.ExternalResultMessageBefore"></span>{{ctrl.SearchTerm}}<span ng-bind-html="ctrl.ExternalResultMessageAfter"></span></div></div>',
    };
};



// WEBPACK FOOTER //
// ./src/search/search-externalresult.directive.js